module.exports = __webpack_public_path__ + "static/media/18ECA39.3bd564d4.jpg";